import script from "./3-Cols-Block.vue?vue&type=script&setup=true&lang=js"
export * from "./3-Cols-Block.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__